import { MenuButton } from '@fluentui/react-components';
import { WandSparkles } from 'lucide-react';
import { FC } from 'react';
import { t } from 'i18next';
import './ImprovePromptButton.scss';

export interface ImprovePromptButtonProps {
    onClick?: () => void;
    disabled?: boolean;
}

const ImprovePromptButton: FC<ImprovePromptButtonProps> = ({ onClick, disabled }) => {
    return (
        <MenuButton
            icon={<WandSparkles size={40} strokeWidth={1.5} />}
            appearance="transparent"
            size="medium"
            aria-label={t('conversation.actions.improvePrompt')}
            disabled={disabled}
            onClick={onClick}
        />
    );
};

export default ImprovePromptButton;
